import styled from "styled-components";

interface Props {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}

export const Spacer = styled.div<Props>`
  margin-top: ${({ top }) => top}px;
  margin-bottom: ${({ bottom }) => bottom}px;
  margin-left: ${({ left }) => left}px;
  margin-right: ${({ right }) => right}px;
`;
